[
    {
        "objectType": "Test",
        "displayName": "Test Object"
    },
    {
        "objectType": "StageObject",
        "displayName": "Stage Object"
    },
    {
        "objectType": "Item",
        "displayName": "Item"
    },
    {
        "objectType": "Enemy",
        "displayName": "Enemy"
    },
    {
        "objectType": "Other",
        "displayName": "Other"
    },
    {
        "objectType": "NFT",
        "displayName": "NFT"
    }
]